console.log('variant-image-sets loaded');
(() => {
  // Ändra om din option heter nåt annat än Color/Färg
  const COLOR_OPTION_NAMES = ['color', 'färg', 'colour'];

  const handleize = (s) => (s || '')
    .toString()
    .trim()
    .toLowerCase()
    .replace(/å/g, 'a').replace(/ä/g, 'a').replace(/ö/g, 'o')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');

  function getSelectedColorValue() {
    // Variant-radios/selects i Dawn/Horizon-liknande teman
    const groups = document.querySelectorAll(
      'variant-radios fieldset, variant-selects .product-form__input, .product-form__input'
    );

    for (const group of groups) {
      const legend = group.querySelector('legend')?.textContent || '';
      const name = handleize(legend);
      if (!COLOR_OPTION_NAMES.includes(name)) continue;

      const checked = group.querySelector('input[type="radio"]:checked');
      if (checked) return checked.value;

      const select = group.querySelector('select');
      if (select) return select.value;
    }

    return null;
  }

  function filterGalleryByColor(colorValue) {
    if (!colorValue) return;

    const key = '#color_' + handleize(colorValue);

    // Dawn/Horizon: media-gallery custom element finns ofta
    const gallery =
      document.querySelector('media-gallery') ||
      document.querySelector('[data-media-gallery]') ||
      document.querySelector('.product__media-wrapper');

    if (!gallery) return;

    // Media items brukar bära data-media-id / product__media-item
    const items = Array.from(
      gallery.querySelectorAll('[data-media-id], .product__media-item, .media, .swiper-slide, li')
    );

    // Om inga items hittas: avbryt tyst
    if (!items.length) return;

    // Kolla om det ens finns matchande bilder för vald färg
    const matches = items.filter(el => {
      const alt = (el.querySelector('img')?.getAttribute('alt') || '').toLowerCase();
      return alt.includes(key);
    });

    // Om inga bilder är taggade för just den färgen -> visa allt (fallback)
    const shouldFilter = matches.length > 0;

    let firstVisible = null;

    for (const el of items) {
      const alt = (el.querySelector('img')?.getAttribute('alt') || '').toLowerCase();
      const show = !shouldFilter || alt.includes(key);

      el.style.display = show ? '' : 'none';
      el.setAttribute('aria-hidden', show ? 'false' : 'true');

      if (show && !firstVisible) firstVisible = el;
    }

    // Försök hoppa till första synliga bilden
    if (firstVisible) {
      // vissa gallerier lyssnar på click på thumbnails; detta är safe fallback:
      firstVisible.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
  }

  function run() {
    const color = getSelectedColorValue();
    filterGalleryByColor(color);
  }

  // 1) Kör vid load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // 2) Kör vid variant change (många moderna teman dispatchar detta)
  document.addEventListener('variant:change', run); // :contentReference[oaicite:1]{index=1}

  // 3) Fallback: lyssna på change på variant inputs
  document.addEventListener('change', (e) => {
    const t = e.target;
    if (!t) return;
    if (t.closest('variant-radios, variant-selects, .product-form__input')) run();
  });
})();